<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 p-0">
          <div class="login-card">
            <div>
              <div class="login-main">
                <div class="text-center">
                  <img
                    class="img-fluid"
                    src="../assets/new_logo_minedu.png"
                    alt="loginpage"
                    style="width: 100%"
                  />
                </div>

                <vee-form
                  :validation-schema="baseFormSchema"
                  @submit="login"
                  class="theme-form"
                >
                  <h4 style="text-align: center; padding: 10px 0">
                    Eventos - Torneos
                  </h4>
                  <div class="text-center">
                    <img
                      class="img-fluid"
                      :src="icon"
                      alt="loginpage"
                      style="width: 100px"
                    />
                  </div>

                  <div class="form-group">
                    <label class="col-form-label glabel">Usuario</label>
                    <vee-field
                      class="form-control"
                      name="username"
                      type="text"
                      placeholder="Usuario"
                    />
                    <ErrorMessage class="text-danger" name="username" />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label glabel">Contraseña</label>
                    <vee-field
                      class="form-control"
                      name="password"
                      type="password"
                      placeholder="Contraseña"
                    />
                    <ErrorMessage class="text-danger" name="password" />
                  </div>
                  <div class="form-group">
                    <label class="col-form-label glabel">Institución</label>
                    <vee-field
                      as="select"
                      name="type"
                      class="form-control"
                      v-model="kind"
                      @change="changeMode"
                    >
                      <option value="" disabled>
                        Seleccione una institución
                      </option>
                      <option value="1">Ministerio de Educación</option>
                      <option value="2">SIE</option>
                    </vee-field>
                    <ErrorMessage class="text-danger" name="type" />
                  </div>
                  <div class="form-group mb-0">
                    <div class="checkbox p-0">
                      <div class="text-end mt-3">
                        <button
                          class="btn btn-success btn-block w-100"
                          type="submit"
                        >
                          Ingresar
                        </button>
                      </div>
                    </div>
                  </div>
                </vee-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import { decodePayload } from "@/includes/connection";

import authService from "@/services/authService";

const router = useRouter();

const kind = ref("");
const icon = ref(require("@/assets/cup.png"));

const baseFormSchema = {
  username: "required",
  password: "required",
  type: "required",
};

async function login(values, { resetForm }) {
  try {
    const response = await authService.login(values);
    const profile = response.data.user.external_id;
    if (response.data.token) {
      const fullName =
        response.data.user.name + " " + response.data.user.first_last_name;
      localStorage.setItem(
        "User",
        JSON.stringify({
          id: response.data.user.id,
          email: fullName,
          username: response.data.user.username,
          useer: true,
          role: response.data.role?.name,
          roleId: response.data.role?.id,
        })
      );
      if (values.type == "2") {
        localStorage.setItem("profile", profile);
      } else {
        console.log("load", response.data);
        const profileMinedu = response.data.user.external_source_id;
        localStorage.setItem("profile", profileMinedu);
        localStorage.setItem("currentRol", response.data.role?.name);
        localStorage.setItem("currentRolId", response.data.role?.id);
      }
      localStorage.setItem("token", response.data.token);
      const token = response.data.token;
      const payload = decodePayload(token);
      if (payload && payload.exp) {
        localStorage.setItem("exp", payload.exp * 1000);
        console.log("exp", payload.exp * 1000);
      }
      localStorage.setItem("type", values.type);
      localStorage.setItem("username", response.data.userId);
      localStorage.setItem("userId", response.data.user.id);
      localStorage.setItem("place", response.data.place);

      window.location.href = "/";
    } else {
      toast.error("Credenciales no validas!");
    }
  } catch (error) {
    console.log("error ::: ", error);

    if (error.response) {
      switch (error.response.status) {
        case 429:
          toast.error(
            "Demasiados Intentos!! vuelve a intentarlo en unos minutos."
          );
          break;
        default:
          toast.error(error.response.data.message);
          break;
      }
    } else {
      toast.error("Error interno del servidor!!!");
    }
  }
}

function changeMode() {
  if (kind.value == "1") {
    icon.value = require("@/assets/medalla.png");
  } else if (kind.value == "2") {
    icon.value = require("@/assets/cup.png");
  }
}
</script>

<style>
.login-card {
  background: linear-gradient(to right, #000a23, #557996) !important;
}

.glabel {
  font-weight: bold;
}
</style>
